<template>
	<transition 
			appear
			:appear-active-class="$_logout_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer fluid"
					:style="$_logout_stylePageContainerStyle()"
					fluid>
				<v-row	v-show="false"
						no-gutters>
					<v-col>
						<iframe :src="url_" />
					</v-col>
				</v-row>
				<v-row class="customVRow">
					<v-col cols="12" class="center">
						<progress-circular />
					</v-col>
				</v-row>
			</v-container>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Logout',
		props: {
			inits: Object
		},
		data() {
			return {
				pageName_: 'logout',
				pageType_: 'logout',

				initialized_: false,
				// bo ipc url for logout
				url_: null
			}
		},
		computed: {
			// state
			$_logout_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_logout_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_logout_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_logout_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_logout_inits(), 'contact')
			},
			// style
			$_logout_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_logout_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_logout_inits(), 'page')
				}
			},
			$_logout_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_logout_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_logout_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_logout_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_logout_inits(), 'pageContainer')
			},
			$_logout_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_logout_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_logout_setPageState()

			if(self_.$_logout_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_logout_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)

			// custom for bri life start
			const securityGroup_ = self_.getUserState('securityGroupCode')
			if(securityGroup_  == 'ibs' || securityGroup_  == 'adminibs') {
				self_.url_ = 'https://' + self_.ipcDomain + '-ibs.bo-point.id' + '/auth/logout';
			}
			else if(securityGroup_  == 'agency' || securityGroup_  == 'adminagency') {
				self_.url_ = 'https://' + self_.ipcDomain + '-agency.bo-point.id' + '/auth/logout';
			}
			else if(securityGroup_  == 'test') {
				self_.url_ = 'https://' + self_.ipcDomain + '-test.bo-point.id' + '/auth/logout';
			}
			else {
				self_.url_ = self_.ipcUrl + '/auth/logout';
			}
			// custom for bri life end

			setTimeout(() => { self_.$_logout_logout() }, 5000)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_logout_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_logout_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_logout_initialize()', error)
				})
			},
			$_logout_logout() {
				const self_ = this;
				const router_ = self_.$router;

				Promise.resolve().then(() => {
					return self_.firebase.auth().signOut()
				}).then(() => {
					// back to index page & set default menu group
					const link_ = {
						to: '/',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'default'
							}
						}
					}
					self_.openLink(link_)

/* info */			self_.logInfo('Logout', 'User has logged out.')
				})
			}
		}
	}
</script>

<style scoped>
</style>
